import { useEffect } from "react";
import { useTranslation } from "react-i18next";
import { useSessionStore } from "../store/useSessionStore";

const SUPPORTED_LANGUAGES = ["en", "es", "fr"];

/**
 * Syncs the persisted session language to i18n on mount.
 * Ensures that after a page refresh, the language from the claim
 * session takes precedence over the browser's navigator language.
 */
export function useLanguageSync() {
  const { i18n } = useTranslation();
  const sessionLanguage = useSessionStore(
    (state) => state.session.data?.language
  );

  useEffect(() => {
    if (
      sessionLanguage &&
      SUPPORTED_LANGUAGES.includes(sessionLanguage) &&
      i18n.language !== sessionLanguage
    ) {
      i18n.changeLanguage(sessionLanguage);
    }
  }, [sessionLanguage, i18n]);
}
